// Filter configuration for data export form
// This file defines which filter fields are available for each resource type
// when creating data exports.

import {
    agentFilterFields,
    channelFilterFields,
    contactFilterFields,
    conversationFilterFields,
    credentialFilterFields,
    knowledgeBaseFilterFields,
    knowledgeEntryFilterFields,
    paymentFilterFields,
    ticketFilterFields,
    transactionFilterFields,
    userFilterFields
} from '../Shared/Filters/filterConfig';
import { Resource } from '../../Constants/socket';

// Shared filter that applies to all resources
// This filter will be automatically injected into each resource's filters
export const sharedExportFilters = [
    {
        key: 'created_at',
        labelKey: 'filters_field_created_at',
        type: 'dateRange',
        startKey: 'created_at_start',
        endKey: 'created_at_end',
    }
];

// Mapping of resources to their available filter fields
export const resourceFilterMapping = {
    [Resource.USER]: userFilterFields,
    [Resource.CREDENTIAL]: credentialFilterFields,
    [Resource.AGENT]: agentFilterFields,
    [Resource.CHANNEL]: channelFilterFields,
    [Resource.CONTACT]: contactFilterFields,
    [Resource.CONVERSATION]: conversationFilterFields,
    [Resource.KNOWLEDGE_BASE]: knowledgeBaseFilterFields,
    [Resource.KNOWLEDGE_ENTRY]: knowledgeEntryFilterFields,
    [Resource.MESSAGE]: sharedExportFilters, // Inherits global filter for Simple Mode
    [Resource.MEDIA]: sharedExportFilters,
    [Resource.PAYMENT]: paymentFilterFields,
    [Resource.TICKET]: ticketFilterFields,
    [Resource.TICKET_COMMENT]: sharedExportFilters,
    [Resource.TRANSACTION]: transactionFilterFields,
    [Resource.PAYMENT_SETTING]: sharedExportFilters
};
